import { render, staticRenderFns } from "./SignUpView.vue?vue&type=template&id=0bae64a7&scoped=true&"
import script from "./SignUpView.vue?vue&type=script&lang=js&"
export * from "./SignUpView.vue?vue&type=script&lang=js&"
import style0 from "./SignUpView.vue?vue&type=style&index=0&id=0bae64a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae64a7",
  null
  
)

export default component.exports